"use client"
import { classNames, FlexCenter, TextBody, Tooltip, tv } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { useSubscriptionStatus } from "@/hooks/use-subscription/use-subscription-status"

const indicatorVariants = tv({
  base: "size-2 rounded-full",
  variants: {
    status: {
      live: "bg-success-1",
      paused: "bg-warning",
      degraded: "bg-error-1",
    },
  },
})

export function SubscriptionLiveIndicator() {
  const t = useTranslations("SubscriptionLiveIndicator")
  const result = useSubscriptionStatus()

  // Get status text based on result status
  function getStatusText() {
    if (!result) {
      return ""
    }

    switch (result.status) {
      case "paused":
        return t("paused")
      case "degraded":
        return t("degraded")
      default:
        return t("live")
    }
  }
  const statusText = getStatusText()

  // Get tooltip text for degraded status
  function getTooltipText() {
    if (!result || result.status !== "degraded") {
      return ""
    }

    // Only degraded status has a reason property
    return result.reason === "offline" ? t("offlineError") : t("unknownError")
  }

  if (!result) {
    return null
  }

  return (
    <FlexCenter className="gap-2">
      <span className="relative flex size-2">
        <span
          className={classNames(
            indicatorVariants({ status: result.status }),
            "absolute inline-flex size-full animate-ping opacity-75",
          )}
        />
        <span
          className={classNames(
            indicatorVariants({ status: result.status }),
            "relative inline-flex size-2",
          )}
        />
      </span>
      {result.status === "degraded" ? (
        <Tooltip content={getTooltipText()}>
          <TextBody size="xs">{statusText}</TextBody>
        </Tooltip>
      ) : (
        <TextBody size="xs">{statusText}</TextBody>
      )}
    </FlexCenter>
  )
}
